<template>
  <v-container>
    <v-row class="">
      <v-col cols="12">
      </v-col>
        <h1>Privacy Policy</h1>
    </v-row>

    <v-row>
      <v-col cols="12">
        <p>Users' contact and sensitive information is to remain private from all other Users and any non BlueChipCar administrator inquirer. Sensitive information such as users' social security numbers are encrypted, highly secured and absolutely private; required for the only purpose of providing tax documentation such as IRS form 1099 for U.S. citizens and residents at the end of the calendar year per IRS law. Non U.S. users will be required to complete an IRS form W8. </p>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>

  export default {
    name: 'PrivacyPolicy',
  }
</script>
